import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CiWallet } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { removeUser } from "../../api/user";
import Loader from "../../component/Loader";
import Paginations from "../../component/Pagination";
import { variants } from "../../constant/Variants";
import DeleteModal from "./../../component/Modal/Delete";
import Select from "react-select";
import { getTeacherId, getModules } from "../../app/globalStore";
import {
  FetchUserList,
  lists,
  totalUserCountSelector,
  userListSelector,
} from "./UserSlice";

function User() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacher_id = getTeacherId();
  const teacher_modules = getModules() || {};
  const list = useSelector(userListSelector);
  const total = useSelector(totalUserCountSelector);
  
  // Restore pagination state from sessionStorage on component mount
  const [search, setSearch] = useState(() => {
    return sessionStorage.getItem('userListSearch') || "";
  });
  const [show, setShow] = useState(false);
  const [delId, setDelId] = useState("");
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem('userListPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  const [loading, setLoading] = useState(false);
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  // Restore company selection state from sessionStorage on component mount
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const savedCompany = sessionStorage.getItem('userListCompany');
    return savedCompany ? parseInt(savedCompany) : 0;
  });
  const handlePage = (val) => {
    setPage(val);
    sessionStorage.setItem('userListPage', val.toString());
  };

  const handleShow = () => {
    setShow(!show);
  };

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(FetchUserList({ page: page, limit: 10, search: search, company_id:selectedCompany })).then(
      () => {
        setLoading(false);
      }
    );
  }, [dispatch, page, search, selectedCompany]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Save search state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('userListSearch', search);
  }, [search]);

  // Save company selection state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('userListCompany', selectedCompany.toString());
  }, [selectedCompany]);

  const confirmDelete = () => {
    removeUser({ userId: delId }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        getList();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  useEffect(() => {
    return () => {
      dispatch(lists(null));
    };
  }, []);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/users-selected.png" alt="" /> Total
                users {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search user by name"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    sessionStorage.setItem('userListPage', '1');
                    const searchValue = e.target.value;
                    setSearch(searchValue);
                    sessionStorage.setItem('userListSearch', searchValue);
                  }}
                />
              </form>
              <Link to="/add-user" className="">
                <img
                  src="assets/images/addBtn.png"
                  alt=""
                  className="add-new"
                />
              </Link>
            </div>
          </div>
        </div>
        {Array.isArray(companyOptions) && companyOptions.length > 0 && (
        <div className="row">
        <div className="col-md-6 col-lg-3">
        <Select
            options={companyOptions}
            isSearchable
            placeholder="Select a company..."
            value={companyOptions.find(option => option.value === selectedCompany)}
            onChange={option => {
              setSelectedCompany(option.value);
              setPage(1);
              sessionStorage.setItem('userListPage', '1');
            }}
          />
          </div>
        </div>
        )}
        <div className="row">
          <div className="col-sm-9 col-md-9 col-lg-10">
            <ul
              className="nav nav-pills group-nav mb-3"
              id="pills-tab"
              role="tablist"
            >
              {teacher_modules && teacher_modules.user === true && (
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-new-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-new"
                  type="button"
                  role="tab"
                  aria-controls="pills-new"
                  aria-selected="true"
                >
                  Users
                </button>
              </li>
              )}
              {teacher_modules && teacher_modules.student === true && (
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-completed-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-completed"
                  type="button"
                  role="tab"
                  aria-controls="pills-completed"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/student");
                  }}
                >
                  Students
                </button>
              </li>
              )}
            </ul>
          </div>
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Email ID</th>
                    <th scope="col">Date of Birth</th>
                    <th scope="col">Contact Number</th>
                    <th scope="col">Full Address</th>

                    <th scope="col">action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <td colSpan={9}>
                      <Loader />
                    </td>
                  ) : (
                    <>
                      {list?.length > 0 ? (
                        list?.map((item, i) => {
                          return (
                            <tr variants={variants.card} key={i}>
                              <td>{item?.id || "NA"}</td>
                              <td>
                                {item?.first_name ? item?.first_name : "NA"}
                              </td>
                              <td>
                                {item?.last_name ? item?.last_name : "NA"}
                              </td>
                              <td>{item?.username ? item?.username : "NA"}</td>
                              <td>{item?.email ? item?.email : "NA"}</td>
                              <td>
                                {item?.address_details?.dob &&
                                item?.address_details?.dob !== "0000-00-00"
                                  ? moment(item?.address_details?.dob).format(
                                      "DD MMM YYYY"
                                    )
                                  : item?.address_details?.dob_year
                                  ? `${moment(
                                      `${item?.address_details?.dob_year}-${item?.address_details?.dob_month}-${item?.address_details?.dob_day}`
                                    ).format("DD MMM YYYY")}`
                                  : "NA"}
                              </td>
                              <td>
                                {item?.address_details?.mobile
                                  ? `${
                                      item?.address_details?.countryCode
                                        ? item?.address_details?.countryCode
                                        : ""
                                    }${item?.address_details?.mobile}`
                                  : "NA"}
                              </td>
                              <td>
                                {item?.address_details
                                  ? `${
                                      item?.address_details?.property_number
                                        ? `${item?.address_details?.property_number}, `
                                        : ""
                                    }${
                                      item?.address_details?.property_name
                                        ? `${item?.address_details?.property_name}, `
                                        : ""
                                    }${
                                      item?.address_details?.street_number
                                        ? `${item?.address_details?.street_number}, `
                                        : ""
                                    }${
                                      item?.address_details?.town
                                        ? `${item?.address_details?.town}, `
                                        : ""
                                    }${
                                      item?.address_details?.country
                                        ? `${item?.address_details?.country}`
                                        : ""
                                    }${
                                      item?.address_details?.postal_code
                                        ? `-${item?.address_details?.postal_code}`
                                        : ""
                                    }`
                                  : "NA"}
                              </td>

                              <td>
                                <div className="d-flex justify-content-center action">
                                  <button className="btn" title="View User">
                                    <Link to={`/user/${item?.id}`}>
                                      <img
                                        src="assets/images/view.png"
                                        alt=""
                                      />
                                    </Link>
                                  </button>
                                  <button className="btn" title="Edit User">
                                    <Link to={`/edit-user/${item?.id}`}>
                                      <img
                                        src="assets/images/edit.png"
                                        alt=""
                                      />
                                    </Link>
                                  </button>
                                  <button className="btn" title="Wallet History">
                                    <Link to={`/wallet-history/${item?.id}`}>
                                      {/* <img
                                        src="assets/images/payment-refund-selected.png"
                                        alt=""
                                      /> */}
                                      <CiWallet size={25} color="blue"/>
                                    </Link>
                                  </button>
                                  
                                  {teacher_id === 0 && (
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      setDelId(item.id);
                                      handleShow();
                                    }}
                                    title="Delete User"
                                  >
                                    <img
                                      src="assets/images/delete.png"
                                      alt=""
                                    />
                                  </button>
                                )}
                                  {/* <button className="btn">
                                <input
                                  type="checkbox"
                                  className="toggle"
                                  checked=""
                                />
                              </button> */}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10}>No data found.</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {list?.length > 0 && (
            <Paginations
              handlePage={handlePage}
              page={page}
              total={total && total}
            />
          )}
        </div>
      </div>
      <DeleteModal
        page="User"
        show={show}
        handleShow={handleShow}
        cancel={() => {
          setShow(false);
        }}
        confirmDelete={confirmDelete}
      />
    </article>
  );
}

export default User;
